// InterviewQuestion.model.ts

export interface IChoice {
  id?: number;
  choice_text: string;
  is_correct: boolean;
}

export interface IInterviewQuestion {
  id: number;
  user: number;
  question_text: string;
  topic: number;
  topic_name?: string;
  is_active: boolean;
  difficulty_level: number;
  choices: IChoice[];
  created_date?: string;
  updated_date?: string;
}

export interface IInterviewQuestionListProps {
  openNew: () => void;
  loadInterviewQuestions: () => void;
  data: IInterviewQuestion[];
  loading: boolean;
}

export interface IInterviewQuestionFormInput {
  user: number;
  question_text: string;
  topic: number;
  is_active: boolean;
  difficulty_level: number;
  choices: IChoice[];
}

export interface IInterviewQuestionFormProps {
  methods: any;
  onSubmit: (data: IInterviewQuestionFormInput) => void;
  isEdit?: boolean;
}

export interface IInterviewQuestionUpdateProps {
  data: IInterviewQuestion;
  setQuestionDialog: (val: boolean) => void;
  loadInterviewQuestions: () => void;
}

export interface IInterviewQuestionCreateProps {
  setQuestionDialog: (val: boolean) => void;
  loadInterviewQuestions: () => void;
}

export const DIFFICULTY_LEVELS = [
  { label: "Low", value: 1 },
  { label: "Medium", value: 2 },
  { label: "High", value: 3 },
];
